// axios-фасад над @emcd-shared/api-service: только транспорт + инжект токена.
// Интерсептор свой (auth-service/api тянет captcha-service/ui); refresh/2FA/logout — в request.js, т.к. AuthService.logout редиректит на emcd.io и ломает TMA.
import { BaseApiFacade } from "@emcd-shared/api-service";
import { getAccessToken } from "./tokens";

const AUTH_HEADER = "X-Access-Token";
// login/refresh без токена; якорь на конец сегмента, чтобы не матчить /auth/login-history.
const SKIP_AUTH = /\/auth\/(login|refresh)(?:$|[/?])/;

// Инжектит X-Access-Token, если заголовок ещё не проставлен (напр. 2FA-ретрай).
export function requestInterceptor(config) {
  const url = config?.url || "";
  if (SKIP_AUTH.test(url)) return config;
  config.headers = config.headers || {};
  if (config.headers[AUTH_HEADER]) return config;
  const token = getAccessToken();
  if (token) config.headers[AUTH_HEADER] = token;
  return config;
}

export const requestErrorInterceptor = (error) => Promise.reject(error);

export class ApiFacade extends BaseApiFacade {
  // eslint-disable-next-line no-unused-vars
  constructor(app) {
    super();
    // app не нужен — параметр для симметрии с blueprint.

    const endpoint = this.endpointApi?.client;
    // BaseApiFacade оставляет "Missed …"-строку вместо клиента, если env-URL нет.
    if (!endpoint?.interceptors) {
      throw new Error(
        "ApiFacade: endpointApi.client не axios-инстанс — проверь VUE_APP_ENDPOINT_API_URL",
      );
    }

    // response-интерсептор не вешаем: ошибки ответа обрабатывает request.js.
    endpoint.interceptors.request.use(
      requestInterceptor,
      requestErrorInterceptor,
    );
  }
}

export const createApiFacade = (app) => new ApiFacade(app);
